import {Directive, forwardRef} from '@angular/core';
import {NG_VALIDATORS, UntypedFormControl} from '@angular/forms';

/**
 * Required validator - validates form control has content
 * - Undefined considered no content
 * - Null considered no content
 * - String containing only whitespace (ie. spaces, tabs or line breaks) considered no
 *   content.
 * @returns {(c:FormControl)=>any}
 */
function requiredValidatorFactory() {
    return (c: UntypedFormControl) => {
        let error: any = null;

        if (c.value === undefined || c.value === null || !c.value.replace(/\s/g, '').length) {
            return error = {
                requiredValidator: {
                    required: {
                        invalid: true
                    }
                }
            };
        }

        return error;
    };
}

/**
 * Required validator directive
 */
@Directive({
    selector: '[xlog-required-validator][ngModel],[xlog-required-validator][formControl]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => RequiredValidatorDirective), multi: true }
    ],
    standalone: false
})
export class RequiredValidatorDirective {
    validator: Function;

    constructor() {
        this.validator = requiredValidatorFactory();
    }

    validate(c: UntypedFormControl) {
        return this.validator(c);
    }
}
